module.exports = __webpack_public_path__ + "img/left-lightning1.6d0615a7.png";